import React from 'react';
import { isMobile } from 'react-device-detect';
import { Carousel } from 'react-responsive-carousel';

interface BannerProps {
  getBanners: (bannerType: 'mobile' | 'web') => any[];
  navigateToLink: (banner: any) => void;
  adminWhatsAppNumber: string;
}

const Banner: React.FC<BannerProps> = ({
  getBanners,
  navigateToLink,
  adminWhatsAppNumber,
}) => {
    console.log('isMobile', isMobile)
  return (
    <>
      {!isMobile ? (
        <Carousel
          className="web-banners"
          autoPlay={true}
          infiniteLoop={true}
          interval={5000}
          showThumbs={false}
          showStatus={false}
        >
          {getBanners('web').map((banner) => (
            <div key={banner?.text + 'container'}>
              <img
                loading="lazy"
                onClick={() => {
                  if (
                    banner.publicUrl.includes('faircric-banner1') ||
                    banner.publicUrl.includes('faircric-banner2')
                  ) {
                    window.location.href = `http://api.whatsapp.com/send?phone=${adminWhatsAppNumber}`;
                  } else {
                    navigateToLink(banner);
                  }
                }}
                className="banner-images"
                src={banner?.publicUrl}
                key={banner?.text + 'image'}
                alt={banner?.text}
                title={banner?.text}
              />
            </div>
          ))}
        </Carousel>
      ) : (
        <Carousel
          className="mob-banners"
          autoPlay={true}
          infiniteLoop={true}
          interval={5000}
          showThumbs={false}
          showStatus={false}
        >
          {getBanners('mobile').map((banner) => (
            <div key={banner.text + 'container'}>
              <img
                loading="lazy"
                onClick={() => {
                  if (
                    banner.publicUrl.includes('faircric-+mob_banner1') ||
                    banner.publicUrl.includes('faircric-mob_banner1') ||
                    banner.publicUrl.includes('faircric-+mob_banner2') ||
                    banner.publicUrl.includes('faircric-mob_banner2')
                  ) {
                    window.location.href = `http://api.whatsapp.com/send?phone=${adminWhatsAppNumber}`;
                  } else {
                    navigateToLink(banner);
                  }
                }}
                className="banner-images"
                src={banner.publicUrl}
                key={banner.text + 'image'}
                alt={banner.text}
                title={banner.text}
              />
            </div>
          ))}
        </Carousel>
      )}
    </>
  );
};

export default Banner;
